import { GroupBusinessReport } from '../../../service/incomeApi';

/**
 * 生成随机门店数据（Mock）
 */
export function generateMockStoreData(storeId: number, storeName: string): GroupBusinessReport {
  // 生成随机数据，模拟真实业务数据
  // 使用当前时间戳作为随机种子的一部分，确保每次调用都生成不同的数据
  const timeSeed = Date.now();
  let randomCounter = 0; // 计数器，确保每次调用seededRandom都生成不同的值

  // 使用种子化的随机数生成器（简化版）
  const seededRandom = () => {
    randomCounter++;
    const seed = timeSeed + storeId + randomCounter;
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  };

  const baseRevenue = 50000 + seededRandom() * 100000;
  const occupancyRate = 50 + seededRandom() * 40; // 50-90%
  const roomTotal = 50 + Math.floor(seededRandom() * 100); // 50-150间
  const roomTake = Math.floor(roomTotal * occupancyRate / 100);
  const adr = 200 + seededRandom() * 300; // 200-500元

  return {
    id: storeId,
    hotelId: storeId,
    hotelName: storeName,
    hotelCode: `HOTEL${String(storeId).padStart(3, '0')}`,
    date: Math.floor(Date.now() / 1000), // 使用当前时间戳，确保每次不同

    // 房间相关
    roomTotal,
    roomAvaliable: roomTotal - roomTake,
    roomTake,
    roomRepair: Math.floor(seededRandom() * 5),
    roomLock: Math.floor(seededRandom() * 3),
    roomNight: roomTake,
    roomOvernight: roomTake,
    hourSum: Math.floor(seededRandom() * 100),
    hourScale: seededRandom() * 10,
    earlyCheckout: Math.floor(seededRandom() * 3),
    addHalf: null,
    addDay: Math.floor(seededRandom() * 2),
    addHour: Math.floor(seededRandom() * 5),
    addUp: Math.floor(seededRandom() * 10),
    noshow: Math.floor(seededRandom() * 2),

    // 指标
    occupancyRate,
    roomOvernightRate: occupancyRate,
    adr,
    avgListPrice: adr * 1.2,
    avgPrice: adr,
    discountRate: 20 + Math.random() * 30,
    roomRevpar: adr * occupancyRate / 100,
    allRevpar: adr * occupancyRate / 100 * 1.1,
    newOccupancyRate: occupancyRate,

    // 收入
    roomRevenue: baseRevenue * 0.7,
    unRoomRevenue: baseRevenue * 0.3,
    allRevenue: baseRevenue,
    membershipRevenue: baseRevenue * 0.15,
    foodRevenue: baseRevenue * 0.1,
    goodsRevenue: baseRevenue * 0.05,
    serverRevenue: baseRevenue * 0.05,
    otherRevenue: baseRevenue * 0.05,

    // 散客
    fitRoomNight: Math.floor(roomTake * (0.3 + seededRandom() * 0.2)),
    fitRoomNightRate: 30 + seededRandom() * 20,
    fitRoomNightRevenue: baseRevenue * 0.3,
    fitRoomNightRevenueAvg: adr * 0.9,

    // 团队
    teamRoomNight: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    teamRoomNightRate: 10 + seededRandom() * 10,
    teamRoomNightRevenue: baseRevenue * 0.15,
    teamRoomNightRevenueAvg: adr * 0.85,

    // 会员
    memberRoomNight: Math.floor(roomTake * (0.2 + seededRandom() * 0.2)),
    memberRoomNightRate: 20 + seededRandom() * 20,
    memberRoomNightRevenue: baseRevenue * 0.15,
    memberRoomNightRevenueAvg: adr * 0.95,

    // 单位
    unitRoomNight: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    unitRoomNightRate: 10 + seededRandom() * 10,
    unitRoomNightRevenue: baseRevenue * 0.1,
    unitRoomNightRevenueAvg: adr * 0.9,

    // 企业直连
    qyzlUnitRoomNight: Math.floor(roomTake * (0.05 + seededRandom() * 0.05)),
    qyzlUnitRoomNightRate: 5 + seededRandom() * 5,
    qyzlUnitRoomNightRevenue: baseRevenue * 0.05,
    qyzlUnitRoomNightRevenueAvg: adr * 0.9,

    // 长租
    clUnitRoomNight: Math.floor(roomTake * (0.05 + seededRandom() * 0.05)),
    clUnitRoomNightRate: 5 + seededRandom() * 5,
    clUnitRoomNightRevenue: baseRevenue * 0.05,
    clUnitRoomNightRevenueAvg: adr * 0.8,

    // 直连
    directLinkUnitRoomNightRevenue: baseRevenue * 0.1,
    directLinkUnitRoomNightRevenueAvg: adr * 0.9,

    // 小程序
    miniUnitRoomNight: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    miniUnitRoomNightRate: 10 + seededRandom() * 10,
    miniUnitRoomNightRevenue: baseRevenue * 0.1,
    miniUnitRoomNightRevenueAvg: adr * 0.95,

    // 介绍
    introRoomNight: Math.floor(roomTake * (0.05 + seededRandom() * 0.05)),
    introRoomNightRate: 5 + seededRandom() * 5,
    introRoomNightRevenue: baseRevenue * 0.05,
    introRoomNightRevenueAvg: adr * 0.9,

    // OTA
    otaRoomNight: Math.floor(roomTake * (0.2 + seededRandom() * 0.2)),
    otaRoomNightRate: 20 + seededRandom() * 20,
    otaRoomNightRevenue: baseRevenue * 0.2,
    otaRoomNightRevenueAvg: adr * 0.85,

    // 订单
    orderRoomTake: roomTake,
    orderRoomCheckout: roomTake,

    // 系统字段
    userId: 1,
    status: 1,
    createTime: Math.floor(Date.now() / 1000), // 使用当前时间戳
    updateTime: Math.floor(Date.now() / 1000), // 使用当前时间戳，确保每次不同

    // 门店
    storesRoomNight: Math.floor(roomTake * (0.15 + seededRandom() * 0.1)),
    storesRoomNightRate: 15 + seededRandom() * 10,
    storesRoomNightRevenue: baseRevenue * 0.15,
    storesRoomNightRevenueAvg: adr * 0.95,

    // 企业前台
    qyFrontDeskNight: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    qyFrontDeskNightRate: 10 + seededRandom() * 10,
    qyFrontDeskNightRevenue: baseRevenue * 0.1,
    qyFrontDeskNightRevenueAvg: adr * 0.9,

    // 门店团队
    storesTeamRoomNight: Math.floor(roomTake * (0.05 + seededRandom() * 0.05)),
    storesTeamRoomNightRate: 5 + seededRandom() * 5,
    storesTeamRoomNightRevenue: baseRevenue * 0.05,
    storesTeamRoomNightRevenueAvg: adr * 0.85,

    // 全天房夜数
    fullDayRoomNight: roomTake,

    // 门店协议
    storeAgreementTotalRoomNights: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    storeAgreementTotalRoomNightsRate: 10 + seededRandom() * 10,
    storeAgreementTotalRoomNightsRevenue: baseRevenue * 0.1,
    storeAgreementTotalRoomNightsRevenueAvg: adr * 0.9,

    // 会员总数
    memberTotalRoomNights: Math.floor(roomTake * (0.2 + seededRandom() * 0.2)),
    memberTotalRoomNightsRate: 20 + seededRandom() * 20,
    memberTotalRoomNightsRevenue: baseRevenue * 0.15,
    memberTotalRoomNightsRevenueAvg: adr * 0.95,

    // 线下会员
    offlineMemberRoomNights: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    offlineMemberRoomNightsRate: 10 + seededRandom() * 10,
    offlineMemberRoomNightsRevenue: baseRevenue * 0.1,
    offlineMemberRoomNightsRevenueAvg: adr * 0.95,

    // 商旅会员
    corporateTravelMemberRoomNights: Math.floor(roomTake * (0.05 + seededRandom() * 0.05)),
    corporateTravelMemberRoomNightsRate: 5 + seededRandom() * 5,
    corporateTravelMemberRoomNightsRevenue: baseRevenue * 0.05,
    corporateTravelMemberRoomNightsRevenueAvg: adr * 0.9,

    // 代理
    agencyTotalRoomNights: Math.floor(roomTake * (0.1 + seededRandom() * 0.1)),
    agencyTotalRoomNightsRate: 10 + seededRandom() * 10,
    agencyTotalRoomNightsRevenue: baseRevenue * 0.1,
    agencyTotalRoomNightsRevenueAvg: adr * 0.85,

    // 其他字段
    brandName: '测试品牌',
    brandId: 1,
    onlineStatus: 2,
    offlineTime: 0,
    month: new Date().toISOString().slice(0, 7),
    year: new Date().getFullYear(),
    hotelOpenDate: Math.floor(Date.now() / 1000) - 365 * 24 * 60 * 60,
    regionName: '测试区域',
    regionId: 1,
    areaNames: '测试区域',
    roomNum: roomTotal,
    newMemberCount: Math.floor(Math.random() * 10),
  };
}

/**
 * 生成多个门店的Mock数据
 */
export function generateMockStoresData(count: number = 10): Array<{ storeId: number; storeName: string; data: GroupBusinessReport }> {
  const stores: Array<{ storeId: number; storeName: string; data: GroupBusinessReport }> = [];

  for (let i = 1; i <= count; i++) {
    const storeId = i;
    const storeName = `门店${i}`;
    stores.push({
      storeId,
      storeName,
      data: generateMockStoreData(storeId, storeName),
    });
  }

  return stores;
}
